import { all } from "redux-saga/effects"
import UsersListSaga from "./handlers/usersList"
import CurrentUserSaga from "./handlers/currentUser"
import ApplicationSaga from "./handlers/application"
import RolesSaga from "./handlers/rolesList"
import PermissionsSaga from "./handlers/permissions"
// import ConfigSaga from "./config.saga"

export default function* watcherSaga(getState) {
  yield all([
    // ConfigSaga(),
    UsersListSaga(),
    CurrentUserSaga(),
    ApplicationSaga(),
    RolesSaga(),
    PermissionsSaga(),
  ])
}
